import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ICiudad, IComuna, IRegion } from '../Entities/entities';
import { IComunaColectivo } from '../Entities/productoColectivo.entities';
import { key_user_info } from '../helpers/constants';
import { getLocalStorage } from '../helpers/helper';

@Injectable({
  providedIn: 'root',
})
export class UbicationService {
  constructor(private http: HttpClient) {}

  getRegiones(): Observable<IRegion[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Ubicaciones/ListarRegiones/${userInfo.rut}`
      )
      .pipe(
        map(res => {
          return res.Region;
        })
      );
  }

  getCiudades(codigoRegion: string): Observable<ICiudad[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Ubicaciones/ListarCiudadesPorRegion/${userInfo.rut}/${codigoRegion}`
      )
      .pipe(
        map(res => {
          if (res) {
            return res.Ciudad;
          } else {
            return null;
          }
        })
      );
  }

  getComunas(codigoCiudad?: string): Observable<IComuna[]> {
    const userInfo = getLocalStorage(key_user_info);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Ubicaciones/ListarComunasPorCiudad/${userInfo.rut}/${codigoCiudad}`
      )
      .pipe(
        map(res => {
          if (res) {
            return res.Comuna;
          } else {
            return null;
          }
        })
      );
  }
}
